/**
 * Клиент для работы с API магнит
 * @module API/client
 * */

import axios from 'axios'
import { LocalStorage } from 'quasar'
import Config from "../modules/Config";

const axiosClient = axios.create({
  timeout: 100000,
  baseURL: Config.API_PREFIX,
  headers: {
    'Content-Type': 'application/json'
  },
  maxContentLength: 10000
})

axiosClient.interceptors.request.use(
  async config => {
    const response = await axios.post(`${Config.API_PREFIX}auth_client/authentication`)
    const TOKEN = response.data.token
    const authenticationToken = LocalStorage.getItem('authentication_token')
    if (authenticationToken) {
      config.headers.Authorization = `bearer ${authenticationToken}`
    } else {
      config.headers.Authorization = `bearer ${TOKEN}`
    }
    return config
  },
  error => Promise.reject(error)
)

export default axiosClient
